<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { bus } from '@core/events/eventSystem';
import constants from '@core/utils/constants';

const showRules = ref(false);
const rules = ref([]);
const loading = ref(true);

onMounted(() => {
  bus.emit(constants.EVENTS.REWARDS.LOAD_RULES);

  const handleRulesLoaded = (data: any[]) => {
    rules.value = Array.isArray(data) ? data : [];
    loading.value = false;
  };

  bus.on(constants.EVENTS.REWARDS.RULES_LOADED, handleRulesLoaded);

  onUnmounted(() => {
    bus.off(constants.EVENTS.REWARDS.RULES_LOADED, handleRulesLoaded);
  });
});
</script>

<template>
  <div
    class="w-full h-full fixed top-0 left-0 z-40"
    @click="showRules = false"
    v-if="showRules"
  ></div>
  <div
    class="fixed left-full z-50 w-[80vw] h-[70vh] bottom-[18vh] duration-300"
    :class="{ 'translate-x-[-80vw]': showRules }"
  >
    <div class="liquidGlassCard w-full pr-1 rounded-l-4xl h-full z-2 relative ">
      <div class="overflow-scroll h-full p-4">
        <header class="mb-4">
          <h1 class="text-2xl font-bold title-color">
            Récompenses Rapidoo
          </h1>
          <p class="text-xs text-gray-500 font-medium">
            Obtenez des récompenses pour chaque action que vous effectuez sur la
            plateforme
          </p>
        </header>

        <div class="flex flex-col gap-4 mt-6">
          <div
            v-for="rule in rules"
            :key="rule.id"
            class="bg-white/50 border border-primary/30 p-4 rounded-2xl transition-all hover:bg-white/10"
          >
            <h3 class="font-bold text-primary text-xl">{{ rule.name }}</h3>

            <div class="flex gap-2">
              <span
                class="flex items-center gap-1 bg-white text-amber-600 font-bold px-2 py-1 rounded-full border border-amber-500/30"
              >
                ✨ {{ rule.xp }} XP
              </span>
              <span
                class="flex items-center gap-1 bg-white text-blue-400 font-bold px-2 py-1 rounded-full border border-blue-500/30"
              >
                💎 {{ rule.points }} pts
              </span>
            </div>

            <p class="title-color mt-2 text-sm leading-relaxed">
              {{ rule.description }}
            </p>

            <!-- Optionnel: indicateur d'état -->
            <div class="mt-3 flex justify-end">
              <span
                v-if="!rule.isActive"
                class="text-[10px] uppercase tracking-wider text-gray-500 italic"
              >
                (Temporairement indisponible)
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      @click="showRules = !showRules"
      class="w-16 h-16 rounded-l-full liquidGlassCard absolute right-full top-[80%] text-primary flex justify-center items-center"
    >
      <ColorImg src="/images/all/star.png" class="bg-primary w-8 h-8" alt=""/>
    </div>
  </div>
</template>
